// Bidirectional slug aliases so each language can have its own URL.
//
// Two sources of posts:
//   1. WordPress-imported posts — canonical slug is English (WP);
//      TR readers see a Turkish alias.  -> WP_SLUG_TR
//   2. Locally created posts (in the `posts` table) — canonical slug is
//      Turkish; EN readers see an English alias.  -> POST_SLUG_EN
//
// `canonicalSlug(slug)` resolves any alias back to the canonical DB slug
// before fetching. `displaySlug(slug, lang)` returns the URL slug that
// should be shown for the current language.
//
// IMPORTANT: every new locally-created post MUST be added to POST_SLUG_EN
// so the EN version of the site has an English URL. Skipping this leaves
// EN readers on a Turkish URL.

export const WP_SLUG_TR: Record<string, string> = {
  "truth-and-trust-the-battlefield-of-information":
    "hakikat-ve-guven-bilginin-savas-alani",
  "the-sustainability-industry-as-parasite":
    "surdurulebilirlik-sektoru-krizden-kar-saglamak",
};

export const POST_SLUG_EN: Record<string, string> = {
  "verimlilik-maskeli-obur": "efficiency-masked-glutton",
};

// Reverse maps
const TR_SLUG_TO_WP: Record<string, string> = Object.fromEntries(
  Object.entries(WP_SLUG_TR).map(([wp, tr]) => [tr, wp]),
);
const EN_SLUG_TO_POST: Record<string, string> = Object.fromEntries(
  Object.entries(POST_SLUG_EN).map(([post, en]) => [en, post]),
);

/** Resolve any alias (TR alias of a WP post, or EN alias of a local post) back to its canonical DB slug. */
export function canonicalSlug(slug: string): string {
  return TR_SLUG_TO_WP[slug] ?? EN_SLUG_TO_POST[slug] ?? slug;
}

/** Display slug for the given language. Accepts canonical or already-aliased input. */
export function displaySlug(slug: string, lang: "en" | "tr"): string {
  const canon = canonicalSlug(slug);
  if (lang === "tr") return WP_SLUG_TR[canon] ?? canon;
  return POST_SLUG_EN[canon] ?? canon;
}
